import React from 'react';

interface FlyerCompositionSwatchProps {
  layoutId: string;
}

const base: React.CSSProperties = {
  position: 'relative',
  width: 42,
  height: 52,
  flex: '0 0 auto',
  overflow: 'hidden',
  border: '1px solid #bfdbfe',
  borderRadius: 5,
  background: '#071a3a',
};

const line = (
  top: number,
  left: number,
  width: number,
  height = 3,
  color = '#f8fafc'
): React.CSSProperties => ({
  position: 'absolute',
  top,
  left,
  width,
  height,
  borderRadius: 2,
  background: color,
});

const visualByLayout = (layoutId: string): React.ReactNode => {
  switch (layoutId) {
    case 'editorial-blueprint':
      return (
        <>
          <span style={line(8, 6, 25)} />
          <span style={line(14, 6, 18, 2)} />
          <span
            style={{
              position: 'absolute',
              top: 23,
              left: 8,
              width: 26,
              height: 17,
              border: '1px solid #38bdf8',
            }}
          />
          <span style={line(31, 3, 36, 1, '#38bdf8')} />
        </>
      );
    case 'tech-pulse':
      return (
        <>
          <span style={line(7, 6, 28)} />
          {[20, 24, 28].map((inset) => (
            <span
              key={inset}
              style={{
                position: 'absolute',
                inset,
                top: inset,
                bottom: 52 - inset - 14,
                border: '1px solid #38bdf8',
                borderRadius: '50%',
              }}
            />
          ))}
        </>
      );
    case 'kinetic-systems':
      return (
        <>
          <span
            style={{
              ...line(7, -4, 52, 8, '#2563eb'),
              transform: 'rotate(-12deg)',
            }}
          />
          <span style={line(15, 6, 28)} />
          <span
            style={{
              position: 'absolute',
              top: 29,
              left: 2,
              width: 38,
              height: 12,
              borderTop: '2px solid #38bdf8',
              borderRadius: '50%',
              transform: 'rotate(8deg)',
            }}
          />
        </>
      );
    case 'layered-platform':
      return (
        <>
          <span style={line(7, 6, 28)} />
          {[0, 1, 2, 3].map((index) => (
            <span
              key={index}
              style={{
                position: 'absolute',
                top: 22 + index * 5,
                left: 7 + index,
                width: 28 - index * 2,
                height: 8,
                borderRadius: 5,
                background: index % 2 ? '#2563eb' : '#38bdf8',
              }}
            />
          ))}
        </>
      );
    case 'retro-technical':
      return (
        <>
          <span style={line(6, 5, 18)} />
          <span
            style={{
              position: 'absolute',
              top: 18,
              right: 4,
              width: 18,
              height: 18,
              border: '5px solid #38bdf8',
              borderRadius: '50%',
            }}
          />
          <span style={line(20, 5, 13, 18)} />
          <span style={line(43, 0, 42, 9, '#f59e0b')} />
        </>
      );
    default:
      return (
        <>
          <span style={line(7, 6, 28)} />
          <span style={line(14, 6, 20, 2)} />
          <span
            style={{
              position: 'absolute',
              top: 23,
              left: 11,
              width: 20,
              height: 16,
              borderRadius: 5,
              background: '#0ea5e9',
              boxShadow: '0 5px 0 #2563eb, 0 10px 0 #1d4ed8',
            }}
          />
        </>
      );
  }
};

const FlyerCompositionSwatch: React.FC<FlyerCompositionSwatchProps> = ({
  layoutId,
}) => <span style={base}>{visualByLayout(layoutId)}</span>;

export default FlyerCompositionSwatch;
